import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'oiq-email-list-item-skeleton',
  standalone: true,
  imports: [],
  templateUrl: './email-list-item-skeleton.component.html',
  styleUrl: './email-list-item-skeleton.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    '[class.oiq-email-list-item-skeleton]': 'true',
  },
})
export class EmailListItemSkeletonComponent {}
